import type { ChangeReasons } from '@/Network/Types/Requests/ChangeReasonRequests'

/** Espelho de `AllocationInviteMode` do backend (BE-1). `REPLACE_NOW` chega com o PR #3525. */
export enum AllocationInviteMode {
  /** Vaga aberta. */
  VACANCY = 'VACANCY',
  /** Substituição: o médico atual sai na criação do convite. */
  REPLACE_NOW = 'REPLACE_NOW',
  /** Substituição: o médico atual fica até o aceite. */
  REPLACE_KEEP = 'REPLACE_KEEP'
}

export interface AllocationInvitePreviewRequest {
  scheduleId: number
  stationIds: number[]
  doctorIds: number[]
  mode: AllocationInviteMode
}

/** Lista branca do backend (D78): só estes três campos do passo 1 são reaplicados no aceite. */
export interface AllocationInviteAllocationPayload {
  dsPaymentDoctorFormationId?: number | null
  ourTeam?: boolean
  userSponsorId?: number | null
}

export interface CreateAllocationInviteRequest extends AllocationInvitePreviewRequest {
  allocationPayload: AllocationInviteAllocationPayload
  /** D104: motivo da remoção do médico atual; só vai no `REPLACE_NOW` (os outros modos ignoram). */
  changeReasons?: ChangeReasons
}

export interface PendingCommitmentsRequest {
  stationIds: number[]
}
